export const styles = {
  progress: {
    color: "events.bluePrimary",
  },
};
